// extracted by mini-css-extract-plugin
module.exports = {"sideTools":"sideTools--3M0qR","text":"text--3tWXi","contactModal":"contactModal--2Tjac"};